<script lang="ts">
    import Link  from "svelte-link";
    import {Button,Modal, ModalHeader,ModalBody, ModalFooter,Popover } from "sveltestrap";
    import { Close, href, Modaltitle, Popoverinamodal, Savechanges, Tooltipsandpopovers, Tooltipsinamodal } from "../../../../utils/Constant/Constant";
    let open: boolean = false;
    const toggle = () => (open = !open);
</script>

<Button color="primary" on:click={toggle}>{Tooltipsandpopovers}</Button>
<Modal isOpen={open} {toggle}>
    <ModalHeader {toggle}>
        {Modaltitle}
        <Button class="btn-close" aria-label="Close" />
    </ModalHeader>
    <ModalBody>
        <h5>{Popoverinamodal}</h5>
        <p>This
            <Link class="btn btn-primary popover-test" href={href} role="button" id="btn" >button</Link>
            <Popover placement="right" target="btn">
                This is button. 
            </Popover>  triggers a popover on click.</p>
        <hr>
        <h5>{Tooltipsinamodal}</h5>
        <p><Link class="tooltip-test" href={href} id="link">that link</Link> 
            <Popover placement="right" target="link">
                This is button. 
            </Popover> have tooltips on hover.
        </p>
    </ModalBody>
    <ModalFooter>
        <Button color="secondary" on:click={toggle}>{Close}</Button>
        <Button color="primary" on:click={toggle}>{Savechanges}</Button>
    </ModalFooter>
</Modal>